// Represents list of dataSources for editable fields in Grids that uses dropdown
const Datasources = {
  routeName: {
    storeName: "IBPlanningStore",
    storeVariable: "routeNameList",
  },
  routeAssigned: {
    storeName: "IBPlanningStore",
    storeVariable: "deliveryRouteNameList",
  },
  driverPreference: {
    storeName: "IBPlanningStore",
    storeVariable: "driverPreferencesList",
  },
  liftgate: {
    storeName: "CommonStore",
    storeVariable: "liftgateList",
  },
  anchorPointName: {
    storeName: "CommonStore",
    storeVariable: "anchorPointList",
  },
  status: {
    storeName: "CommonStore",
    storeVariable: "lockOptionsList",
  },
  trailerName: {
    storeName: "CommonStore",
    storeVariable: "trailersList",
  },
  equipmentSizes: {
    storeName: "CommonStore",
    storeVariable: "equipmentSizes",
  },
  isTrapRoute: {
    storeName: "CommonStore",
    storeVariable: "routeTypeList",
  },
  tractorNumber: {
    storeName: "DispatchStore",
    storeVariable: "tractorList",
  },
  dispatchRouteName: {
    storeName: "DispatchStore",
    storeVariable: "dispatchRouteList",
  },
  dispatchDrivers: {
    storeName: "DispatchStore",
    storeVariable: "dispatchDrivers",
  },
  recommendedDriverName: {
    storeName: "DispatchStore",
    storeVariable: "activeDriversList",
  },
  packageCode: {
    storeName: "DispatchStore",
    storeVariable: "packageCodes",
  },
  packageCodeWithSuffix: {
    storeName: "DispatchStore",
    storeVariable: "packageCodesWithSuffix",
  },
  serviceLevel: {
    storeName: "DispatchStore",
    storeVariable: "serviceLevelShipmentOptions",
  },
  dispatchedDriversList: {
    storeName: "DispatchStore",
    storeVariable: "dispatchedDriversListForOptimization",
  },
  maxEquipSizes: {
    storeName: "CustomerStore",
    storeVariable: "maxEquipSizes",
  },
  minEquipSizes: {
    storeName: "CustomerStore",
    storeVariable: "minEquipSizes",
  },
  fixedEquipSizes: {
    storeName: "CustomerStore",
    storeVariable: "fixedEquipSizes",
  },
  overrideRoutes: {
    storeName: "CustomerStore",
    storeVariable: "overrideRoutes",
  },
  door: {
    storeName: "IBPlanningStore",
    storeVariable: "doorDataList",
  },
  holidayOptions: {
    storeName: "IBPlanningStore",
    storeVariable: "holidayOptions",
  },
  isCargoVanEligible: {
    storeName: "CommonStore",
    storeVariable: "twoManList",
  },
  isTwoManRequired: {
    storeName: "CommonStore",
    storeVariable: "cargoVanEligibleList",
  }
};

export default Datasources;